<template>
    <div class="app-container global-container" :class="{ 'dark-mode': darkMode }">
      <div class="sidebar-container" :class="{ 'active': activeSidebar }">
        <Sidebar />
      </div>
      <div class="global-container-wrapper" :class="{ 'mobileSidebarActive': activeSidebar }">
        <div class="global-container-header">
          <Toolbar />
        </div>
        <div class="global-container-content">
          <router-view />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Sidebar from '@/components/Sidebar.vue'
  import Toolbar from '@/components/Toolbar.vue'
  import folders from '@/utils/folders';
  import { mapState, mapActions } from 'vuex';
  
  export default {
    name: 'App',
    components: {
      Sidebar,
      Toolbar
    },
    computed: {
      ...mapState(['darkMode', 'activeSidebar']),
    }, 
  }
  </script>
  
  <style>
    html {
      overflow-x: hidden;
      overflow-y: auto;
    }
    .app-container.global-container {
      display: flex;
      width: 100%;
      max-width: none;
      margin: 0;
      min-height: 100vh;
    }

    .sidebar-container {
      width: 240px;
      min-width: 240px;
      flex-shrink: 0;
    }

    .global-container-wrapper {
      flex: 1;
      min-width: 0;
      width: calc(100% - 240px);
    }

    .global-container-content {
      width: 100%;
    }

    /* Evita scroll duplo: css-master fixa altura em .page .page-wrapper.primary,
       mas o conteúdo já está dentro do dashboard com toolbar. */
    .global-container-content .page .page-wrapper.primary {
      overflow-y: visible;
      height: auto;
      min-height: 0;
    }
 
    section.section.page-body.primary {
      background-color:#f7f7f7;
  }
.wizard .diagram-data.primary {
  scrollbar-width: none;
  -ms-overflow-style: none; 
}
.wizard .diagram-data.primary::-webkit-scrollbar {
    display: none;
}
/* DARK MODE */
.dark-mode .global-container-wrapper {
        background-color: #161618;
    }
  </style>
  